
/*
Plugin: jQuery Parallax
Version 1.1.3
Author: Ian Lunn
Twitter: @IanLunn
Author URL: http://www.ianlunn.co.uk/
Plugin URL: http://www.ianlunn.co.uk/plugins/jquery-parallax/

Dual licensed under the MIT and GPL licenses:
http://www.opensource.org/licenses/mit-license.php
http://www.gnu.org/licenses/gpl.html
*/

(function( $ ){
	var $window = $(window);
	var windowHeight = $window.height();

	$window.resize(function () {
		windowHeight = $window.height();
	});

	$.fn.parallax = function(xpos, speedFactor, outerHeight) {
		var $this = $(this);
		var getHeight;
		var firstTop;
		var paddingTop = 0;

		//get the starting position of each element to have parallax applied to it
		function update (){

			$this.each(function(){

				firstTop = $this.offset().top;
			});

			if (outerHeight) {
				getHeight = function(jqo) {
					return jqo.outerHeight(true);
				};
			} else {
				getHeight = function(jqo) {
					return jqo.height();
				};
			}

			// setup defaults if arguments aren't specified
			if (arguments.length < 1 || xpos === null) xpos = "50%";
			if (arguments.length < 2 || speedFactor === null) speedFactor = 0.5;
			if (arguments.length < 3 || outerHeight === null) outerHeight = true;

			// function to be called whenever the window is scrolled or resized

				var pos = $window.scrollTop();

				$this.each(function(){
					var $element = $(this);
					var top = $element.offset().top;
					var height = getHeight($element);

					// Check if totally above or totally below viewport
					if (top + height < pos || top > pos + windowHeight) {
						return;
					}

					//$this.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px");
					$this.find('img').each(function(){
						$(this).css('marginTop',Math.round(( -(top-pos)) * speedFactor) + "px");
					});
					$this.find('.parallax-block').each(function(){
						$(this).css('marginTop',Math.round(( -(top-pos)) * speedFactor) + "px");
					});
				});
		}

		$window.bind('scroll', update).resize(update);
		update();
	};
})(jQuery);

/*! tCycle (c) 2013 M.Alsup MIT/GPL 20131130 */
(function ($) {
    "use strict";
    $.fn.tcycle = function () {

        return this.each(function () {
            var i = 0, c = $(this), s = c.children(), o = $.extend({
                    speed:   500,
                    timeout: 4000
                }, c.data()), f = o.fx != 'scroll',
                l = s.length, w = c.width(), z = o.speed, t = o.timeout, css = {overflow: 'hidden'}, p = 'position', a = 'absolute',
                tfn = function () {
                    setTimeout(tx, t);
                }, scss = $.extend({position: a, top: 0}, f ? {left: 0} : {left: w}, o.scss);
            if (c.css(p) == 'static')
                css[p] = 'relative';
            if (!l) return;
            lazyLoad(s[0]);
            // c.prepend($(s[0]).clone().css('visibility', 'hidden')).css(css);
            s.css(scss);
            if (f)
                s.hide().eq(0).show();
            else
                s.eq(0).css('left', 0);
            setTimeout(tx, t);

            function lazyLoad(el) {
                if (el.tagName.toUpperCase() == 'IMG') {
                    if (!el.getAttribute('src')) el.setAttribute('src', el.dataset['src']);
                } else if (el.tagName == 'VIDEO') {
                    var p = tcyclePlayers[el.dataset['video']];
                    if (p) {
                        //p.play();
                    }
                }
            }

            function tx() {
                var s = c.children();
                var l = s.length;
                var n = i == (l - 1) ? 0 : (i + 1), w = c.width(), a = $(s[i]), b = $(s[n]);
                if (f) {
                    a.fadeOut(z);
                    // lazyLoad(b[0]);
                    b.fadeIn(z, tfn);
                } else {
                    // lazyLoad(b[0]);
                    a.animate({left: -w}, z, function () {
                        a.hide();
                    });
                    b.css({'left': w, display: 'block'}).animate({left: 0}, z, tfn);
                }
                i = i == (l - 1) ? 0 : (i + 1);
            }
        });

    };
    $(function () {
        $('.tcycle').tcycle();
    });
})(jQuery);

function asElement(element) {
    if (element instanceof HTMLElement) {
        return element;
    } else if (typeof element === typeof '') {
        return document.getElementById(element);
    }
    throw new TypeError("Element should be instance of HTMLElement or string");
}
function asElements(element, parent) {
    if ( parent === void 0 ) parent=document;

    if (typeof element === typeof '') {
        return parent.querySelectorAll(element);
    } else {
        return [element];
    }
}

function inViewport(el) {

    var r, html;
    if (!el || 1 !== el.nodeType) {
        return false;
    }
    html = document.documentElement;
    r = el.getBoundingClientRect();

    return ( !!r
        && r.bottom >= 0
        && r.right >= 0
        && r.top <= html.clientHeight
        && r.left <= html.clientWidth
    );
}

var OperationButton = function OperationButton(selector, parent) {
    if ( parent === void 0 ) parent=document;

    this.btn = asElements(selector, parent);
};

OperationButton.prototype.start = function start () {
        var this$1 = this;

    if (this.btn && this.btn.length) {
        for (var i = 0; i < this.btn.length; ++i) {
            var btn = this$1.btn[i];
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('pending_operation');
        }
    }
};

OperationButton.prototype.stop = function stop () {
        var this$1 = this;

    if (this.btn && this.btn.length) {
        for (var i = 0; i < this.btn.length; ++i) {
            var btn = this$1.btn[i];
            btn.removeAttribute('disabled');
            btn.classList.remove('pending_operation');
        }
    }
};

var youtubeLoaded = false;
var youtubeLoading = false;
// check if Promise is supported by browser
if(typeof Promise !== "undefined" && Promise.toString().indexOf("[native code]") !== -1){
    var youtubePromise = Promise.reject().catch(function (){});

    window.initYoutube = function () {
        if (youtubeLoaded) return Promise.resolve();
        if (youtubeLoading) return youtubePromise;
        youtubeLoading = true;
        youtubePromise = new Promise(function (resolve) {
            window.onYouTubeIframeAPIReady = function (){
                youtubeLoaded = true;
                resolve();
            };

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            tag.async = true;
            //var firstScriptTag = document.getElementsByTagName('script')[0];
            //firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            document.body.appendChild(tag);
        });
        return youtubePromise;
    };
}
function onStateChangeFun(event) {
    if (event.data == 3) {
        ga('send', 'event', 'videos', 'play', event.target.F.videoData.video_id);
    } else if (event.data == 0) {
        ga('send', 'event', 'videos', 'end', event.target.F.videoData.video_id);
    }
}

window.initPlayer = function (player, playerVars, events) {
    if ( playerVars === void 0 ) playerVars = {};
    if ( events === void 0 ) events = {};

    if (player.initialized) return null;
    player.initialized = true;
    player.classList.add('loading');
    var p = new YT.Player(player, {
        //height:     '390',
        //width:      '640',
        videoId: player.dataset['video'],
        playerVars: Object.assign({
            loop: 0,
            autoplay: 0,
            controls: 0,
            showinfo: 0,
            rel: 0
        }, playerVars),
        events: Object.assign({
            'onStateChange': onStateChangeFun,
            'onReady': function () {
                player.classList.remove('loading');
            }
        }, events)
    });
    return p;
};

var FileUploader = function FileUploader(cont) {
    this.fileId = 0;
    this.filesCont = cont;
    $(this.filesCont).on('click', '.attachment-delete', function (e) {
        var id = this.parentNode.dataset['id'];
        $(this.parentNode).remove();
    });
};

FileUploader.prototype.loadend = function loadend (reader, file) {
    var hdl = ++this.fileId;
    var tpl = Template.render('file_entry_tpl', {
        name: file.name,
        id: hdl
    });
    var entry = document.getElementById('file_entry');
    entry.setAttribute('name', 'files');
    entry.onchange = null;
    var entryParent = entry.parentNode;
    entry.removeAttribute('id');
    tpl.querySelector('.attachment').appendChild(entry);
    var newEntry = document.createElement('input');
    newEntry.setAttribute('id', 'file_entry');
    newEntry.setAttribute('hidden', 'hidden');
    newEntry.setAttribute('type', 'file');
    var uploader = this;
    $(newEntry).on('change', function () {
        uploader.readFiles(this.files);
    });
    entryParent.appendChild(newEntry);
    this.filesCont.appendChild(tpl);
    return hdl;
};

FileUploader.prototype.removeFile = function removeFile (hdl) {
    this.files.erase(hdl);
};

FileUploader.prototype.readFiles = function readFiles (files) {
        var this$1 = this;

    for (var i = 0; i < files.length; ++i) {
        var file = files[i];
        var reader = new FileReader();
        if (file) {
            reader.onloadend = this$1.loadend.bind(this$1, reader, file);
            reader.readAsDataURL(file);
        }
    }
};

var Ajax = function Ajax () {};

Ajax.submitForm = function submitForm (form, data, ajax_header) {
        if ( data === void 0 ) data='';
        if ( ajax_header === void 0 ) ajax_header = true;

    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();

        xhr.open('POST', form.getAttribute('action'), true);
        xhr.onreadystatechange = function (e) {
            if (xhr.readyState == 4) {
                if (xhr.status == 200) {
                    form.reset();
                    return resolve(xhr.response);
                }
                reject(xhr);
            }
        };
        if (ajax_header) {
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        if (!data) {
            data = new FormData(form);
        }
        xhr.send(data);
    });
};

var Modal = function Modal(id) {
    var this$1 = this;

    this.node = document.getElementById(id);
    this.node.addEventListener('click', function (e){
        if (e.target.matches('.overlay, .close')) {
            this$1.hide();
        }
    }, false);
};

Modal.prototype.show = function show () {
    document.body.classList.add('no_scroll');
    this.node.removeAttribute('hidden');
};

Modal.prototype.hide = function hide () {
    document.body.classList.remove('no_scroll');
    this.node.setAttribute('hidden', 'hidden')
};

var TabbedModal = (function (Modal) {
    function TabbedModal(id) {
        Modal.call(this, id);
        this.form = this.node.querySelector('form');
        if (this.form) {
            this.setupForm(this.form);
        }
        this.errorMessage = document.getElementById('failure_reason');
    }

    if ( Modal ) TabbedModal.__proto__ = Modal;
    TabbedModal.prototype = Object.create( Modal && Modal.prototype );
    TabbedModal.prototype.constructor = TabbedModal;

    TabbedModal.prototype.setupForm = function setupForm (node) {
        node.onsubmit = this.send.bind(this);
    };

    TabbedModal.prototype.send = function send (e) {
        var this$1 = this;

        e.preventDefault();
        this.switchTab('sending');
        Ajax.submitForm(this.form).then(function () {
            this$1.switchTab('ok');
            setTimeout(function () {
                this$1.hide();
            }, 5000)
        }).catch(function (xhr) {
            if (xhr.status < 500) {
                this$1.errorMessage.innerHTML = xhr.responseText;
            } else {
                this$1.errorMessage.innerHTML = 'неизвестная ошибка';
            }
            this$1.switchTab('fail');
            setTimeout(function () {
                this$1.switchTab('form');
            }, 5000)
        });
    };

    TabbedModal.prototype.switchTab = function switchTab (tabName) {
        var visible = this.node.querySelector(".tab:not([hidden])");
        if (visible) {
            visible.setAttribute('hidden', 'hidden');
        }
        var tab = this.node.querySelector(("[data-tab=\"" + tabName + "\"]"));
        if (tab) {
            tab.removeAttribute('hidden');
        }
    };

    TabbedModal.prototype.show = function show () {
        this.switchTab('form');
        Modal.prototype.show.call(this);
    };

    TabbedModal.prototype.hide = function hide () {
        this.switchTab('form');
        Modal.prototype.hide.call(this);
    };

    return TabbedModal;
}(Modal));

var VideoModal = (function (Modal) {
    function VideoModal(id) {
        Modal.call(this, id);
        this.playerContainer = this.node.querySelector('.modal-player');
        this.title = this.node.querySelector('.title');
    }

    if ( Modal ) VideoModal.__proto__ = Modal;
    VideoModal.prototype = Object.create( Modal && Modal.prototype );
    VideoModal.prototype.constructor = VideoModal;

    VideoModal.prototype.setSource = function setSource (src) {
        this.playerContainer.dataset['video'] = src;
    };

    VideoModal.prototype.setTitle = function setTitle (title) {
        this.title.innerHTML = title;
    };

    VideoModal.prototype.switchTab = function switchTab (tabName) {
        var visible = this.node.querySelector(".tab:not([hidden])");
        if (visible) {
            visible.setAttribute('hidden', 'hidden');
        }
        var tab = this.node.querySelector(("[data-tab=\"" + tabName + "\"]"));
        if (tab) {
            tab.removeAttribute('hidden');
        }
    };

    VideoModal.prototype.show = function show () {
        var this$1 = this;

        this.switchTab('loading');
        Modal.prototype.show.call(this);
        initYoutube().then(function (){
            if (this$1.playerContainer) {
                this$1.playerContainer.initialized = false;
                this$1.player = initPlayer(this$1.playerContainer);
            }
            this$1.switchTab('video');
        }).catch(function (){
            this$1.switchTab('fail');
        });
    };

    VideoModal.prototype.hide = function hide () {
        if (this.player) {
            try {
                this.player.stopVideo();
            } catch (e) {
            }
            this.player.destroy();
        }
        Modal.prototype.hide.call(this);
    };

    return VideoModal;
}(Modal));

var Carousel = function Carousel(container) {
    this.container = container.querySelector('.carousel');
    this.larr = container.querySelector('.carousel-arr-larr');
    this.rarr = container.querySelector('.carousel-arr-rarr');

    this.larr.addEventListener('click', this.prev.bind(this), true);
    this.rarr.addEventListener('click', this.next.bind(this), true);
};

var PageableCarousel = (function (Carousel) {
    function PageableCarousel(container) {
        Carousel.call(this, container);
        this.initPage();
        this.baseUrl = '/';
    }

    if ( Carousel ) PageableCarousel.__proto__ = Carousel;
    PageableCarousel.prototype = Object.create( Carousel && Carousel.prototype );
    PageableCarousel.prototype.constructor = PageableCarousel;

    PageableCarousel.prototype.initPage = function initPage () {

    };

    PageableCarousel.prototype.load = function load (page) {
        $(this.container).load(((this.baseUrl) + "?page=" + page), this.initPage.bind(this));
    };

    PageableCarousel.prototype.advancePage = function advancePage (adv) {
        if (-this.container.dataset['pages']) {
            var new_page = (Number(this.container.dataset['page']) + Number(adv)) % Number(this.container.dataset['pages']);
            if (new_page<0) {
                new_page = Number(this.container.dataset['pages']) + new_page;
            }
            this.container.dataset['page'] = new_page;
            return new_page
        } else {
            return 0;
        }
    };

    PageableCarousel.prototype.next = function next () {
        this.load(this.advancePage(1));
    };

    PageableCarousel.prototype.prev = function prev () {
        this.load(this.advancePage(-1));
    };

    return PageableCarousel;
}(Carousel));
// window.Template = {
//     interpolateVar(string, variable, value) {
//         return string.replace(new RegExp(`([^$])\\$\{${variable}\}`, 'g'), `$1${value}`)
//     },
//     render:function(template, data) {
//         let t = (typeof template == typeof '') ? document.getElementById(template) : template;
//         if (!(t instanceof HTMLTemplateElement)) {
//             throw new Error('invalid template');
//         }
//
//         let clone = document.importNode(t.content, true);
//         let cached = {};
//         for (let selector in data) {
//             let [sel, attr] = selector.split('@');
//             let node = cached[sel];
//             if (!node) {
//                 if (sel) {
//                     node = clone.querySelector(sel);
//                     cached[sel] = node;
//                 }
//             }
//             if (!attr) {
//                 node.innerHTML = data[selector];
//             } else {
//                 if (attr.startsWith('#')) {
//                     let variable = attr.substr(1);
//                     let value = data[selector];
//                     if (node) {
//                         node.innerHTML = Template.interpolateVar(node.innerHTML, variable, value);
//                     } else {
//                         for (let i=0; i<clone.childNodes.length; ++i) {
//                             let child = clone.childNodes[i];
//                             switch (child.nodeType) {
//                                 case Node.ELEMENT_NODE:
//                                     child.innerHTML = Template.interpolateVar(child.innerHTML, variable, value);
//                                     break;
//                                 case Node.TEXT_NODE:
//                                     child.nodeValue = Template.interpolateVar(child.nodeValue, variable, value);
//                                     break;
//                                 default:;
//                             }
//                         }
//                         // clone.textContent.replace(new RegExp(`([^$])\\$\{${attr.substr(1)}\}`, 'g'), `$1${data[selector]}`);
//                     }
//                 } else {
//                     node.setAttribute(attr, data[selector]);
//                 }
//             }
//         }
//         return clone;
//     }
// };

var Template = {
    interpolateVar: function interpolateVar(string, variable, value) {
        return string.replace(new RegExp(("([^$])?\\${" + variable + "}"), 'g'), ("$1" + value))
    },
    interpolateChildren: function interpolateChildren(node, variable, value) {
        for (var i = 0; i < node.childNodes.length; ++i) {
            var child = node.childNodes[i];
            // Template.interpolateRecursive(child, variable, value);
            if (child.nodeType == Node.ELEMENT_NODE) {
                for (var i = 0; i < child.attributes.length; i++){
                    var attr = child.attributes[i];
                    child.setAttribute(attr.name, Template.interpolateVar(attr.textContent, variable, value))
                }
            }

            switch (child.nodeType) {
                case Node.ELEMENT_NODE:
                    child.innerHTML = Template.interpolateVar(child.innerHTML, variable, value);
                    break;
                case Node.TEXT_NODE:
                    child.nodeValue = Template.interpolateVar(child.nodeValue, variable, value);
                    break;
                default:
                    ;
            }
        }
    },
    resolve: function resolve(expr, context){
        if ([ExpType.MEMBER_EXP, ExpType.IDENTIFIER].includes(expr.type)) {
            if (expr.type == ExpType.IDENTIFIER) {
                return context[expr.name] || '';
            }
            try {
                var obj = Template.resolve(expr.object, context);
                // TODO: resolver context chain
                return expr.property.type == ExpType.LITERAL ? obj[expr.property.value] : Template.resolve(expr.property, obj);
            } catch (e) {
                return '';
            }
        } else {
            return '';
        }
    },
    render: function (template, data) {
        var t = (typeof template == typeof '') ? document.getElementById(template) : template;
        if (!(t instanceof HTMLTemplateElement)) {
            throw new Error('invalid template');
        }

        var clone = document.importNode(t.content, true);
        var cached = {};
        for (var selector in data) {
            if (selector.startsWith('=')) {
                var ref = selector.split('@');
                var sel = ref[0];
                var attr = ref[1];
                sel = sel.substr(1);
                var node = cached[sel];
                if (!node) {
                    if (sel) {
                        node = clone.querySelector(sel);
                        cached[sel] = node;
                    }
                }

                if (!attr) {
                    node.innerHTML = data[selector];
                } else {
                    node.setAttribute(attr, data[selector]);
                }
            } else {
                Template.interpolateChildren(clone, selector, data[selector]);
            }
        }
        return clone;
    }
};


$(document).ready(function (){

    // STICKY HEADER

    // Create a clone of the menu, right next to original.
    var $menu = $('.head_nav');

    if ($menu.length) {
    //let scrollIntervalID = setInterval(stickIt, 10);
        var aboveStick = document.getElementById($menu[0].dataset['stick']);
        var offset = aboveStick?$(aboveStick).height():0;

        var sticked = false;

        window.stickIt = function () {

            if ($(window).scrollTop() >= offset) {
                $menu.addClass('sticky');
                // scrolled past the original position; now only show the cloned, sticky element.

                // Cloned element should always have same left position and width as original element.
                if (!sticked) {
                    sticked = true;
                    if (window.menuStickHook) {
                        window.menuStickHook(sticked);
                    }
                }
            } else {
                // not scrolled past the menu; only show the original menu.
                if (sticked) {
                    $menu.removeClass('sticky');
                    sticked = false;
                    if (window.menuStickHook) {
                        window.menuStickHook(sticked);
                    }
                }
            }
        };

        stickIt();
    }
    // Disable pointer events

    var timer;
    window.addEventListener('scroll', function () {
        if (window.stickIt) stickIt();
        clearTimeout(timer);
        if (!document.body.classList.contains('disable-hover')) {
            document.body.classList.add('disable-hover')
        }

        timer = setTimeout(function () {
            document.body.classList.remove('disable-hover')
        }, 200);
    }, false);

    // MENU
    window.selectMenu = function(hash) {
        var $newhash = $('[href="'+hash+'"]');
        if ($newhash.length) {
            $menu.find('.cat_active').removeClass('cat_active');
            $newhash.each(function (e) {
                $(this).parent().addClass('cat_active');
            });
        }
    };

    // WAYPOINTS
    window.menuScroll = false;

    window.waypoints = document.querySelectorAll('a[name]');

    var currentState = '';
    Array.prototype.forEach.call(waypoints, function (e){
        (function(e) {
            var waypoint = new Waypoint({
                element: e,
                handler: function (direction) {
                    if (e.getAttribute('name') == currentState) return;
                    if (!menuScroll) {
                        currentState = e.getAttribute('name');
                        selectMenu(("#" + (e.getAttribute('name'))));
                    }
                    //window.location.hash=currentState;
                    //if (currentState=='address') {
                    //    if (!mapAdded) loadMaps().then(()=>{
                    //        ymaps.ready(init);
                    //    });
                    //}
                },
                offset: $('#mainmenu').data('offset') || 50
            })
        })(e)
    });


    // COMMERCIAL OFFER

    var offer = document.getElementById('send_commercial_offer');
    if (offer) {
        var supply_modal = new TabbedModal('suppy_request_modal');
        var filesContainer = document.querySelector('.modal--supply .files_list');
        var uploader = new FileUploader(filesContainer);
        var supply_select = document.getElementById('supply_request_subject');
        $('#file_entry').on('change', function () {
            uploader.readFiles(this.files);
        });
        if (supply_select) {
            supply_select.selectedIndex=-1;
        }

        $(offer).on('click', function (e) {
            e.preventDefault();
            supply_modal.show();
        }).on('focus', 'input[type="tel"]', function () {
            if (!this.value) {
                this.value = '+7-9';
            }
        }).on('blur', 'input[type="tel"]', function () {
            if (this.value == '+7-9') {
                this.value = '';
            }
        });
    }

    $('a[href*="#"][role="menuitem"]:not([href="#"])').click(function () {
        if ((location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')) && (location.hostname == this.hostname)) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="' + this.hash.slice(1) + '"]');
            if (target.length) {
                window.menuScroll = true;
                selectMenu(this.hash);
                $('html,body').animate({
                    scrollTop: /*target.offset().top*/ target[0].offsetTop - 50
                }, 500, function(){
                    window.menuScroll = false;
                });
                if (window.menuHook) {
                    window.menuHook(this);
                }
                return false;
            }
        }
    });

    $('.accordeon--mobile a').on('click', function (e) {
        if (e.target.parentNode.classList.contains('cat_active')) {
            e.preventDefault();
        }
        $('.accordeon--mobile').toggleClass('active');
    });
    if (!$('.accordeon--mobile').find('.cat_active').length) {
        $('.accordeon--mobile').find('li:first-child').toggleClass('cat_active')
    }
    
    if ($("#shop_map").length > 0 ) {// init map only if #shop_map exists
        var shopMap = new ShopMap('shop_map');
        var initStarted = false;
        $(window).on('DOMContentLoaded load resize scroll', function () {
            if (inViewport(shopMap.node) && !shopMap.map.mapInitialized && !initStarted) {
                initStarted = true;
                shopMap.init();
            }
        });
    }
});

